// extracted by mini-css-extract-plugin
export default {"list":"Nav_list__Y73Z9","link":"Nav_link__+hEE3","download":"Nav_download__gqy4a","main":"Nav_main__b9dLf","mobileNavOpen":"Nav_mobileNavOpen__D97Q6"};